import { useEffect } from "react";
import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import { listTasksGroupByQuarterService } from "../services/listTasksGroupByQuarter.service";
import debounce from "lodash.debounce";

export const useTasksGroupByQuarterQuery = (filters) => {
  const fetchData = useFetch();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        setLoading(true);
        const response = await listTasksGroupByQuarterService(fetchData)({
          ...filters,
        });
        setTasks(response.data);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchTasks, 600);
    debounced();
    return () => debounced.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filters?.status,
    filters?.type,
    filters?.startDate,
    filters?.endDate,
    filters?.year,
    filters?.quarter,
    refresh,
  ]);

  return {
    tasks,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
